import { BasicClient } from "@/utils/httpClient";

export default class Employee {
  client: BasicClient;
  constructor() {
    this.client = new BasicClient();
  }
  getEmployeeById(id, historic = 1): any {
    return this.client.exec(
      "/OnBoarding/UserOnBoarding/" + id + "?historic=" + historic,
      "GET"
    );
  }
  getFileForEmployee(id, file, thumbnail = 1, base64 = 1): any {
    return this.client.exec(
      "/OnBoarding/OnBoardingFile?iduser=" +
        id +
        "&file=" +
        file +
        "&thumbnail=" +
        thumbnail +
        "&base64=" +
        base64,
      "GET"
    );
  }
  getListToDigitalFileForEmployee(idpackage): any {
    return this.client.exec("/eforms/packages/" + idpackage, "GET");
  }
  deleteImgForEmployee(params): any {
    return this.client.exec("/OnBoarding/OnBoardingFile", "DELETE", params);
  }
  postUploadImgForEmployee(iduser, file, field): any {
    return this.client.exec("/OnBoarding/UploadOnBoardingFile", "POST", {
      iduser: iduser,
      file: file,
      field: field
    });
  }
  getAvatar(id) {
    return this.client.exec("/users/" + id + "/avatar", "GET", { imagen: 0 });
  }
  putInfoPersonal(id, config): any {
    return this.client.exec("/OnBoarding/UserOnBoarding/" + id, "PUT", {
      template: config
    });
  }
  appproveLoad(loadId): any {
    return this.client.exec(
      `/v2/uploaddocuments/documentWaiting/${loadId}/changeStatus`,
      "PUT"
    );
  }
  denyLoad(loadId, message): any {
    let params = {
      comments: message
    };
    return this.client.exec(
      `/v2/uploaddocuments/documentWaiting/${loadId}/changeStatus/`,
      "DELETE",
      params,
      false,
      true
    );
  }
  getAvatarEmployees(id) {
    return this.client.renderImage(`/users/profile/avatar/${id}`);
  }
  getDocumentPages(id, hash) {
    return this.client.exec(`/v2/uploaddocuments/pages/${id}/${hash}`, "GET");
  }
  getDocUploadFiles(id, hash, page) {
    return this.client.renderImage(
      `/v2/uploaddocuments/dowloadS3/${id}/${hash}/${page}`
    );
  }

  getDocumentPagesFromFS(idapp, iddoc) {
    return this.client.exec(`/documents/pages/${idapp}/${iddoc}`, "GET");
  }

  getDocUploadFilesFromFS(idapp, iddoc, page) {
    return this.client.renderImage(
      `/documents/view/${idapp}/${iddoc}/png/${page}`
    );
  }
  replaceOnboardingTemplate(iduser, idcompanytemplate) {
    return this.client.exec(
      `/OnBoarding/UserOnBoarding/replace/${iduser}/${idcompanytemplate}`,
      "PUT"
    );
  }

  // lista de pendientes por pagina
  getNewDocumentWaitingPerPage() {
    const url = `/v2/admin/inbox`
    return this.client.exec(url, "GET");
  }

  getDocumentWaitingPerPage(perPage, page, orderParams) {
    let url = `/v2/uploaddocuments/documentWaiting?pagination=${perPage},${page},0`
    if (orderParams) {
      url += '&' + Object.keys(orderParams).map(key => [key, orderParams[key]].map(encodeURIComponent).join('=')).join('&')
    }
    return this.client.exec(url, "GET");
  }
  getAllDocumentWaiting(filter = {}) {
    let url = `/v2/uploaddocuments/documentWaiting?pagination=5000,1,0`
    return this.client.exec(url, "GET", filter);
  }
  getDocumentWaitingFilters(filters) {
    let url = `/v2/uploaddocuments/documentWaitingFilters`
    if (filters) {
      url += '?' + Object.keys(filters).map(key => [key, filters[key]].map(encodeURIComponent).join('=')).join('&')
    }
    return this.client.exec(url, "GET");
  }
  approveSelfServiceInfo(idCarga) {
    return this.client.exec(`/v2/selfservice/${idCarga}`, 'POST')
  }
  rejectSelfServiceInfo(idCarga, msg = '') {
    return this.client.exec(`/v2/manageselfservice/${idCarga}`, 'PATCH', { comments: msg })
  }
  getContactInfo(userId) { 
    return this.client.exec(`/v2/selfservice/${userId}/contact`, 'GET')
  }
  createContactInfo(contactData) {
    return this.client.exec(`/v2/selfservice/manager/contact`, 'POST', contactData)
  }
  updateContactInfo(userId, contactData) {
    return this.client.exec(`/v2/selfservice/${userId}/contact`, 'PUT', contactData)
  }
  getAddressInfo(userId) {
    return this.client.exec(`/v2/selfservice-manager/${userId}/address`, 'GET')
  }
  createAddressInfo(userId, addressData) {
    return this.client.exec(`/v2/selfservice-manager/${userId}/address`, 'POST', addressData)
  }
  updateAddressInfo(userId, addressData) {
    return this.client.exec(`/v2/selfservice-manager/${userId}/address`, 'PUT', addressData)
  }
  getIdentifyInfo(userId) {
    return this.client.exec(`/v2/selfservice-manager/${userId}/me`, 'GET')
  }
  createIdentifyInfo(userId, indentifyData) {
    return this.client.exec(`/v2/selfservice/manager/${userId}/me`, 'POST', indentifyData)
  }
  updateIdentifyInfo(userId, indentifyData) {
    return this.client.exec(`/v2/selfservice/${userId}/me`, 'PUT', indentifyData)
  }
  getBankInfo(userId) {
    return this.client.exec(`/v2/selfservice-manager/${userId}/bank`, 'GET')
  }
  getUserPerceptionAvatar(userId, pending) {
    let url = `/v2/selfservice-manager/${userId}/photo`
    if (pending) url = `/v2/selfservice-manager/${userId}/photo?pending=1`
    return this.client.getFile(url)
  }
  createBankInfo(userId, bankData) {
    return this.client.exec(`/v2/selfservice-manager/${userId}/bank`, 'POST', bankData)
  }
  updateBankInfo(userId, bankData) {
    return this.client.exec(`/v2/selfservice-manager/${userId}/bank`, 'PUT', bankData)
  }
  getPreviewFileForEmployee(id, file, base64 = 1): any {
    return this.client.exec(
      '/OnBoarding/OnBoardingFile?iduser=' +
        id +
        '&file=' +
        file +
        '&base64=' +
        base64,
      'GET'
    )
  }
}
